import { render, staticRenderFns } from "./left_arm_pit.vue?vue&type=template&id=1261b6d4"
import script from "./left_arm_pit.vue?vue&type=script&lang=js"
export * from "./left_arm_pit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports